import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./index.css";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faUser,
  faDashboard,
  faBoxes,
  faPhone,
  faPaperPlane,
  faNoteSticky,
  faComments,
  faSortUp,
  faFileLines,
  faClock,
  faTicket,
  faPhoneVolume,
  faUserCircle,
  faSignOut,
  faBatteryEmpty,
  faBars,
  faFileInvoice,
  faChevronRight,
  faChevronLeft,
  faTicketAlt,
  faDownload,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faUser,
  faDashboard,
  faPhone,
  faPaperPlane,
  faNoteSticky,
  faDownload,
  faComments,
  faSortUp,
  faFileLines,
  faClock,
  faTicket,
  faPhoneVolume,
  faBoxes,

  faUserCircle,
  faSignOut,
  faBatteryEmpty,

  faBars,

  faFileInvoice,
  faChevronRight,
  faChevronLeft,

  faTicketAlt,
  faEdit
);

const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(VueReCaptcha, { siteKey: "6Lfr1MEqAAAAACPKXjtIH9YdxYIxJXd35_QIvvzP" });
app.use(store).use(router).mount("#app");
